import { render, staticRenderFns } from "./PedidoDetalhe.vue?vue&type=template&id=1db03204&scoped=true&"
import script from "./PedidoDetalhe.vue?vue&type=script&lang=js&"
export * from "./PedidoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./PedidoDetalhe.vue?vue&type=style&index=0&id=1db03204&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db03204",
  null
  
)

export default component.exports